// extracted by mini-css-extract-plugin
export default {"status":"styles_status__Lbidm","name":"styles_name__ikyEk"};